export interface Environment {
  apiUrl: string;
  appName: string;
  appEnv: 'development' | 'test' | 'production';
  isDevelopment: boolean;
  isProduction: boolean;
}

export const environment: Environment = {
  apiUrl: import.meta.env.VITE_API_URL || 'http://localhost:8000',
  appName: import.meta.env.VITE_APP_NAME || 'Reconocete Marketplace',
  appEnv:
    (import.meta.env.VITE_APP_ENV as Environment['appEnv']) || 'development',
  isDevelopment: import.meta.env.VITE_APP_ENV !== 'production',
  isProduction: import.meta.env.VITE_APP_ENV === 'production',
};
